import { authAxios, getAuthInfo } from './axiosInstance';

export const messageService = {
    // Récupérer le nombre de messages non lus pour toutes les conversations
    async getUnreadMessagesCount() {
        try {
            const { garageId } = getAuthInfo();
            const response = await authAxios.get(`/chat/garage/${garageId}/unread-count`);
            return response.data.totalUnreadCount || 0;
        } catch (error) {
            console.error('Erreur lors de la récupération du nombre de messages non lus:', error);
            return 0;
        }
    },

    // Récupérer les messages d'une conversation (adaptée au nouveau format)
    async getMessages(inspectionId: string, clientId: string) {
        try {
            const { garageId } = getAuthInfo();
            // Utiliser le format triplet pour les conversations
            const response = await authAxios.get(`/chat/conversations/${inspectionId}/${garageId}/${clientId}/messages`);
            return response.data;
        } catch (error) {
            console.error('Erreur lors de la récupération des messages:', error);
            throw error;
        }
    },

    // Envoyer un message (adapté au nouveau format)
    async sendMessage(message: { inspectionId: string, clientId: string, content: string, type?: string }) {
        try {
            const { garageId } = getAuthInfo();
            const sender = {
                id: garageId,
                type: 'GARAGE',
                name: JSON.parse(localStorage.getItem('user') || '{}').name || 'Garagiste'
            };

            // Générer le conversationId à partir du triplet
            const conversationId = `${message.inspectionId}-${garageId}-${message.clientId}`;

            const response = await authAxios.post(`/chat/messages`, {
                conversationId,
                inspectionId: message.inspectionId,
                content: message.content,
                garageId,
                clientId: message.clientId,
                sender,
                type: message.type || 'TEXT',
                timestamp: new Date()
            });

            return response.data;
        } catch (error) {
            console.error('Erreur lors de l\'envoi du message:', error);
            throw error;
        }
    },

    // Marquer tous les messages d'une conversation comme lus (adapté au nouveau format)
    async markAsRead(inspectionId: string, clientId: string) {
        try {
            const { garageId } = getAuthInfo();

            // Générer le conversationId à partir du triplet
            const conversationId = `${inspectionId}-${garageId}-${clientId}`;

            const response = await authAxios.put(`/chat/messages/${conversationId}/read`, {
                userId: garageId
            });
            return response.data;
        } catch (error) {
            console.error('Erreur lors du marquage des messages comme lus:', error);
            throw error;
        }
    },

    // Récupérer toutes les discussions du garage
    async getGarageDiscussions() {
        try {
            const { garageId } = getAuthInfo();
            const response = await authAxios.get(`/chat/garage/${garageId}/discussions`);
            return response.data;
        } catch (error) {
            console.error('Erreur lors de la récupération des discussions:', error);
            throw error;
        }
    }
};